import { render, staticRenderFns } from "./UpdateBlockForm.vue?vue&type=template&id=3ce1a164&scoped=true&"
import script from "./UpdateBlockForm.vue?vue&type=script&lang=ts&"
export * from "./UpdateBlockForm.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateBlockForm.vue?vue&type=style&index=0&id=3ce1a164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce1a164",
  null
  
)

export default component.exports